import type { FeaturedDoc } from '@utils/featuredDocs'
import './FeaturedDocCard.css'

interface FeaturedDocCardProps {
  doc: FeaturedDoc
  onOpen: (doc: FeaturedDoc) => void
}

export default function FeaturedDocCard({ doc, onOpen }: FeaturedDocCardProps) {
  return (
    <div className="featured-doc-card">
      <div className="featured-doc-card__eyebrow">Featured document</div>
      <h3 className="featured-doc-card__name">{doc.name}</h3>
      <p className="featured-doc-card__description">{doc.description}</p>
      <button
        type="button"
        className="featured-doc-card__open"
        onClick={() => onOpen(doc)}
      >
        Open this document
      </button>
    </div>
  )
}
